import React from 'react';
import Link from 'components/Link';
import Img from 'gatsby-image';
import { FormattedMessage } from 'react-intl';
import VideoModal from 'components/VideoModal';
import YouTube from 'react-youtube';

import './_homeJumbotron.scss';

const HomeJumbotron = (props) => {
    const title = props.jumbotronData.title;
    const headline = props.jumbotronData.headline;
    const startLearning = props.jumbotronData.startLearning;
    const watchVideo = props.jumbotronData.watchVideo;

    return (
        <div className="home-jumbotron">
            <Img sizes={props.image} backgroundColor="rgba(51,102,255,0.4)" className="cover-image" />
            <div className="jumbotron-title">
                <h1 className="bold text-center">{title}</h1>
                <h5 className="text-center">{headline}</h5>
            </div>

            <div className="jumbotron-button-group">
                <Link to="/learn" className="h5 text-center btn-cto">
                    <i className="fa fa-graduation-cap" /> {startLearning}
                </Link>
                <VideoModal buttonClassName="h5 text-center btn-cto w-100" buttonLabel={watchVideo} title={<FormattedMessage id="introVideo"/>}>
                    <YouTube videoId="oEYkgUuBSE0" className="w-100 p-0" opts={{height: 500, playerVars: { autoplay: 1}}}/>
                </VideoModal>
            </div>
        </div>
    )
}

export default HomeJumbotron;



// WEBPACK FOOTER //
// ./src/pages/index/_homeJumbotron.js